<script>
  import { stopPropagation } from "./genericHandlers";

  export let showModal; // boolean

  let dialog; // HTMLDialogElement
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<dialog open={showModal}
  bind:this={dialog}
  on:close={() => (showModal = false)}
  on:click|self={() => dialog.close()}
  class="modal"
  >
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div on:click={stopPropagation}>
    <article>
      <header>
        <button aria-label="Close" rel="prev" on:click={() => dialog.close()}></button>
        <slot name="header" />
      </header>
      <slot />
      <footer>
        <slot name="footer" />
      </footer>
    </article>
  </div>
</dialog>
